export const FAIL_DELETE_RELATIONSHIP =
  'Algo inesperado aconteceu ao excluir o profissional, tente novamente mais tarde.'
